import React, { useState } from 'react';
import { Zap } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../../components/ui/dialog';
import { Button } from '../../components/ui/button';
import { eur } from '../api';
import { goldBtn } from '../ui';
import CompanySuggest from '../report/CompanySuggest';
import PurchaseDialog, { usePrices } from '../PurchaseDialog';

export default function QuickDossier() {
  const prices = usePrices();
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState('');
  const [company, setCompany] = useState(null);
  return (
    <>
      <Button onClick={() => setOpen(true)} className={`${goldBtn} h-11 px-5`} data-testid="quick-dossier-btn">
        <Zap size={15} className="mr-2" />Dossier rapido{prices?.bundle_report_aml ? ` · ${eur(prices.bundle_report_aml.cents)}` : ''}
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#0B0D10] border-[#1F242C] text-[#E5E5E5] rounded-sm max-w-lg" data-testid="quick-dossier-dialog">
          <DialogHeader>
            <DialogTitle className="font-heading text-lg">Dossier rapido</DialogTitle>
            <DialogDescription className="text-[#8A8F97]">Report azienda + reputational check sul legale rappresentante. Cerca l'azienda italiana per ragione sociale o partita IVA.</DialogDescription>
          </DialogHeader>
          <CompanySuggest value={q} onChange={(e) => setQ(e.target.value)} country="IT" onPick={(c) => { setQ(c.name); setOpen(false); setCompany(c); }} />
        </DialogContent>
      </Dialog>
      <PurchaseDialog company={company} open={!!company} onClose={() => setCompany(null)} defaultTemplate="bundle" lockTemplate />
    </>
  );
}
